import type {UnmappedBanner, Banner} from "./type";

export const mapBanner: Banner = (datum: UnmappedBanner) => {
    if (!datum) return
    return {
        id: Number(datum.id),
        image: datum.Image,
        textColor: datum.TextColor,
        weight: Number(datum.OrderNum),
        buttonLink: datum.ButtonLink,
        description: {
            en: datum.DescriptionEn,
            el: datum.Description,
        },
        title: {
            en: datum.TitleEn,
            el: datum.Title,
        },
        subtitle: {
            en: datum.SubTitleEn,
            el: datum.SubTitle,
        },
        buttonText: {
            en: datum.ButtonTextEn,
            el: datum.ButtonText,
        }
    }
}
